import EnvioApp from '../pages/EnvioApp/EnvioApp';
import EnvioAppPorEquipe from '../pages/EnvioApp/EnvioAppPorEquipe';

export default [
    {
        path: '/envio-app',
        component: () => import('@/pages/EnvioApp/Template.vue'),
        children: [
            {
                path: '/envio-app',
                component: EnvioApp 
            },
            {
                path: '/envio-app/equipe',
                component: EnvioAppPorEquipe 
            }
        ]
    }  
]